<template>
  <v-container class="mb-8">
    <ViewHeader :title="$t('message.reviewBooster.title')" />
    <v-card class="card-rounded card">
      <ReviewBoosterConfigEmpty />
    </v-card>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader";
import ReviewBoosterConfigEmpty from "@/components/ConfigEmpty/ReviewBoosterConfigEmpty.vue";

export default {
  name: "ReviewBoosterConfig",
  components: {
    ViewHeader,
    ReviewBoosterConfigEmpty
  }
};
</script>

<style lang="scss" scoped>
.card {
  min-height: 589px;
  position: relative;
}
</style>
